module.exports = "/_next/static/images/whatsapp-2829acd0a1ec3de3b37c27a450d3157b.png";